import axios from 'axios';
const API_URL = process.env.VUE_APP_CONTENT_URL;

class ContentService {
  getHtml(key: string) {
    return axios.get(API_URL + '/api/content/get?type=html&mdID=' + key );
  }
}

export default new ContentService();